// extracted by mini-css-extract-plugin
export default {"actions-menu":"Jobs_actions-menu__KmTNL"};